import React from "react";
import { getColor } from "../util/CC";

export default function ImageGrid(props) {

    const template = window.sitesettings.template_info;
    const {content = {}} = props; 

    const {
        location = "main",
        component = "blank_space",
        container = true,
        data = {},
        injected_data = {},
    } = content;

    const {
        images = []
    } = injected_data;

    const {
        width = 400,
        height = 300,
        padding_y = 0,
        padding_x = 0,
        horizontal_align = "center",
        vertical_align = "center",
        size = "cover",
        gap_y = 10,
        gap_x = 10,
        justify = "center",
        background_colour = 0,
        image_radius = 0,

    } = data;

    const parsePath = (url) => {
        const abs = /^(?:[a-z]+:)?\/\//i;
        return (abs.test(url)) ? url : "https://cdn1.bookmanager.com/i/" + window.san + url;
    }


    const drawImage = (_image, _index) => {

        let _coverStyle = {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: (_image.link) ? "pointer" : "default",
            objectFit: "cover",
            height: height + "px",
            width: width + "px",
            backgroundRepeat: "no-repeat",
            backgroundImage: `url('${parsePath(_image.path)}')`,
            backgroundSize: size,
            backgroundPosition: vertical_align + " " + horizontal_align,
            borderRadius : image_radius+"px"
        }

      


        return (
            <div className={(_image.link) ? "bm-img-link" : ""} title={_image.alt} onClick={() => linkOut(_image)} style={_coverStyle} key={_index}>
                {/* <img style={_imgStyle} src={fetchImage(_image.path)} /> */}
            </div>
        )
    }

    const linkOut = (_image) => {
        if (_image.link) {
            window.open(_image.link, (_image.tab) ? "_blank" : "_self");
        }
    }


    const drawRender = () => {

        const gridStyle = {
            background: getColor(background_colour, template),
            display: 'flex',
            flexWrap: "wrap",
            justifyContent: justify,
            gap: `${gap_y}px ${gap_x}px`,
            padding: `${padding_y}px ${padding_x}px`,
        };

        return (
            <div className={(container) ? "preview-container" : ""}>
                <div style={gridStyle}>
                    {images.map((item, index) => {
                        return drawImage(item, index);
                    })}
                </div>
            </div>
        )
    }


    return drawRender();
}